import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import { getArtisanStatsAction } from '../../../modules/statistics/Actions';
import Stats from './Stats';
import getLangData from '../../../utils/getLangData';
import AdBanner from '../../ads/AdBanner';
import { getMyProductsArtisansAction } from '../../../modules/myProductList/Artisan/Actions';
import { getMyProductsSuppliersAction } from '../../../modules/myProductList/Supplier/Actions';
import {
  artisanProductsIsLoadingSelector,
  artisanProductsSelector
} from '../../../modules/myProductList/Artisan/Selectors';
import {
  supplierProductsIsLoadingSelector,
  supplierProductsSelector
} from '../../../modules/myProductList/Supplier/Selectors';
import { Row } from 'react-bootstrap';
import { Col } from 'reactstrap';
import ProductComp from '../../UI/combine/ProductComp';
import api from '../../../helpers/api';
import Cookies from 'js-cookie';

const CustomerStaticBar = ({
  currentUser,
  getArtisanStatsAction,
  getArtisanProducts,
  getSupplierProducts,
  artisanProducts,
  artisanProductsIsLoading,
  supplierProducts,
  supplierProductsIsLoading,
  customerStats
}) => {
  const lang = Cookies.get('lang')

  const [discountArtisanProducts, setDiscountArtisanProducts] = useState({
    list: [],
    loading: false
  });

  const [discountSupplierProducts, setDiscountSupplierProducts] = useState({
    list: [],
    loading: false
  });
  const statsTranslate = getLangData().stats;
  useEffect(() => {
    getArtisanProducts({
      size: 5,
      offest: 0,
      searchTerm: ''
    });
    // getArtisanProductsPictures();
  }, [getArtisanProducts]);
  useEffect(() => {
    getSupplierProducts({
      size: 5,
      offest: 0,
      searchTerm: ''
    });
    // getArtisanProductsPictures();
  }, [getSupplierProducts]);

  useEffect(() => {
    getDiscountArtisan();
    getDiscountSupplier();
  }, []);

  const getDiscountArtisan = async => {
    setDiscountArtisanProducts({ ...discountArtisanProducts, loading: true });
    try {
      const { data } = api.post(
        '/artisan-product/search-discounted-artisan-products/',
        {
          size: 5,
          offest: 0,
          searchTerm: ''
        }
      );
      setDiscountArtisanProducts({
        ...discountArtisanProducts,
        list: data.content
      });
    } catch (error) {
      setDiscountArtisanProducts({ ...discountArtisanProducts, list: [] });
    } finally {
      setDiscountArtisanProducts({
        ...discountArtisanProducts,
        loading: false
      });
    }
  };

  const getDiscountSupplier = async => {
    setDiscountSupplierProducts({ ...discountSupplierProducts, loading: true });
    try {
      const { data } = api.post(
        '/supplier-product/search-discounted-supplier-products/',
        {
          size: 5,
          offest: 0,
          searchTerm: ''
        }
      );
      setDiscountSupplierProducts({
        ...discountSupplierProducts,
        list: data.content
      });
    } catch (error) {
      setDiscountSupplierProducts({ ...discountSupplierProducts, list: [] });
    } finally {
      setDiscountSupplierProducts({
        ...discountSupplierProducts,
        loading: false
      });
    }
  };
  return (
    <>
      <Row>
        <Col sm='12'>
          <ProductComp
            cardTitle={statsTranslate.recently_added_artisan_products}
            isLoading={artisanProductsIsLoading}
            items={artisanProducts}
            edit={`https://warshatna.com/${lang}/ap`}
            customer
          >
            <a
              href={`https://warshatna.com/${lang}/recently-added`}
              target='_blank'
              className='btn btn-primary'
            >
              {getLangData().components.actions.view_more}
            </a>
          </ProductComp>
        </Col>

        <Col sm='12' className='mt-3'>
          <ProductComp
            cardTitle={statsTranslate.recently_added_supplier_products}
            isLoading={supplierProductsIsLoading}
            items={supplierProducts}
            edit={`https://warshatna.com/${lang}/sp`}
            customer
          >
            <a
              href={`https://warshatna.com/${lang}/recently-added`}
              target='_blank'
              className='btn btn-primary'
            >
              {getLangData().components.actions.view_more}
            </a>
          </ProductComp>
        </Col>
        <Col sm='12' className='mt-3'>
          <ProductComp
            cardTitle={statsTranslate.discount_artisan_products}
            isLoading={discountArtisanProducts.loading}
            items={discountArtisanProducts.list}
            edit={`https://warshatna.com/${lang}/ap`}
            customer
          >
            <a
              href={`https://warshatna.com/${lang}/recently-added`}
              target='_blank'
              className='btn btn-primary'
            >
              {getLangData().components.actions.view_more}
            </a>
          </ProductComp>
        </Col>

        <Col sm='12' className='mt-3'>
          <ProductComp
            cardTitle={statsTranslate.discount_supplier_products}
            isLoading={discountSupplierProducts.loading}
            items={discountSupplierProducts.list}
            edit={`https://warshatna.com/${lang}/sp`}
            customer
          >
            <a
              href={`https://warshatna.com/${lang}/recently-added`}
              target='_blank'
              className='btn btn-primary'
            >
              {getLangData().components.actions.view_more}
            </a>
          </ProductComp>
        </Col>
      </Row>
      {/* <Stats
        title={statsTranslate.today}
        sections={[
          {
            icon: 'icon icon-private-inquiries-warshatna',
            title: statsTranslate.artisan_private_inquiry,
            item: {
              title: statsTranslate.inquiry,
              count: customerStats?.today?.privateArtisanInquiries
            }
          },
          {
            icon: 'icon icon-inquiries-warshatna',
            title: statsTranslate.artisan_public_inquiry,
            item: {
              title: statsTranslate.inquiry,
              count: customerStats?.today?.publicArtisanInquiries
            }
          },
          {
            icon: 'icon icon-private-inquiries-warshatna',
            title: statsTranslate.supplier_private_inquiry,
            item: {
              title: statsTranslate.inquiry,
              count: customerStats?.today?.privateSupplierInquiries
            }
          },
          {
            icon: 'icon icon-inquiries-warshatna',
            title: statsTranslate.supplier_public_inquiry,
            item: {
              title: statsTranslate.inquiry,
              count: customerStats?.today?.publicSupplierInquiries
            }
          }
        ]}
      />
      <Stats
        title={statsTranslate.total}
        sections={[
          {
            icon: 'icon icon-private-inquiries-warshatna',
            title: statsTranslate.artisan_private_inquiry,
            item: {
              title: statsTranslate.inquiry,
              count: customerStats?.total?.privateArtisanInquiries
            }
          },
          {
            icon: 'icon icon-inquiries-warshatna',
            title: statsTranslate.artisan_public_inquiry,
            item: {
              title: statsTranslate.inquiry,
              count: customerStats?.total?.publicArtisanInquiries
            }
          },
          {
            icon: 'icon icon-private-inquiries-warshatna',
            title: statsTranslate.supplier_private_inquiry,
            item: {
              title: statsTranslate.inquiry,
              count: customerStats?.total?.privateSupplierInquiries
            }
          },
          {
            icon: 'icon icon-inquiries-warshatna',
            title: statsTranslate.supplier_public_inquiry,
            item: {
              title: statsTranslate.inquiry,
              count: customerStats?.total?.publicSupplierInquiries
            }
          }
        ]}
      /> */}
    </>
  );
};
const mapStateToProps = (state, props) => {
  return {
    customerStats: state.stats.customerStats,
    currentUser: state.users.currentUser,
    artisanProducts: artisanProductsSelector(state),
    artisanProductsIsLoading: artisanProductsIsLoadingSelector(state),
    supplierProducts: supplierProductsSelector(state),
    supplierProductsIsLoading: supplierProductsIsLoadingSelector(state)
  };
};

export default injectIntl(
  connect(mapStateToProps, {
    //   getArtisans: getArtisansAction,
    getArtisanStatsAction,
    getArtisanProducts: getMyProductsArtisansAction,
    getSupplierProducts: getMyProductsSuppliersAction
  })(CustomerStaticBar)
);
